module.exports = new __parcel__URL__("camp-fire-background.74dc3ffe.jpg").toString();